import i18n from 'i18next';

import { MANAGER } from '@/constants/renonciation';
import { URLS } from '@/constants/urls';

const handleCancellationClick = (manager: string | null | undefined, openModal: () => void): void => {
  if (manager?.trim() === MANAGER.OWN_PROCESS) {
    const popup = window.open(URLS.SURAVENIR_RENONCIATION_URL, '_blank', 'noopener,noreferrer');
    if (!popup) {
      alert(i18n.t('modals.cancelableModal.suravenirPopupBlockedError'));
    }
    return;
  }
  openModal();
};

export default handleCancellationClick;
